import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import _pt from "prop-types";
var _excluded = ["onMouseEnter", "onMouseLeave"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import React, { useState } from 'react';
import IconCaretDown from '@lmig/lmds-react-icons/dist/icons/CaretDown';
import { uniqueId } from '@lmig/lmds-helpers/dist/uniqueId';
import { Field } from '@lmig/lmds-react-field';
import { LoadingSpinner } from '@lmig/lmds-react-loading-spinner';
import { SelectOption } from './SelectOption';
import "./select.css";
import { IconEvo } from './IconEvo';

// NOTE: This interface is no longer used and is included only for compatibility reasons.
// It can be removed in the next major release of Select.
export var Select = function Select(props) {
  var children = props.children,
    defaultValue = props.defaultValue,
    _props$loading = props.loading,
    loading = _props$loading === void 0 ? false : _props$loading,
    loadingIcon = props.loadingIcon,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    innerRef = props.innerRef,
    _props$inputProps = props.inputProps,
    inputProps = _props$inputProps === void 0 ? {} : _props$inputProps,
    _props$isRequired = props.isRequired,
    isRequired = _props$isRequired === void 0 ? true : _props$isRequired,
    _props$name = props.name,
    name = _props$name === void 0 ? '' : _props$name,
    placeholderOption = props.placeholderOption,
    value = props.value,
    id = props.id,
    onMouseEnter = props.onMouseEnter,
    onMouseLeave = props.onMouseLeave;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFocused = _useState2[0],
    setIsFocused = _useState2[1];
  var _useState3 = useState(value !== undefined),
    _useState4 = _slicedToArray(_useState3, 1),
    isControlled = _useState4[0];
  var _useState5 = useState(!!defaultValue),
    _useState6 = _slicedToArray(_useState5, 2),
    hasUncontrolledValue = _useState6[0],
    setHasUncontrolledValue = _useState6[1];
  // NOTE: We replace `lmig-select` with `select-` for compatibility reasons. We can remove this replacement
  // when we're ready to introduce a breaking change (or if we find we don't need this compatibility feature).
  var _useState7 = useState(id || uniqueId('select').replace('lmig-select', 'select-')),
    _useState8 = _slicedToArray(_useState7, 1),
    componentId = _useState8[0];
  var isPopulated = isControlled && Boolean(value) || !isControlled && hasUncontrolledValue;

  /**
   * Extracting possible `onMouseEnter` and `onMouseLeave` from `inputProps` to use within the `handleMouseEnter` and `handleMouseLeave`
   */
  var onMouseEnterInputProp = inputProps.onMouseEnter,
    onMouseLeaveInputProp = inputProps.onMouseLeave,
    restInputProps = _objectWithoutProperties(inputProps, _excluded);

  // Gets called when the select element is clicked
  var handleFocus = function handleFocus(e) {
    var onChange = props.onChange,
      onFocus = props.onFocus;
    var hasValue = !!e.target.value;
    setIsFocused(hasValue);
    if (!isControlled) {
      setHasUncontrolledValue(hasValue);
    }
    if (!isPopulated && hasValue) {
      // Without this, the first time that the user interacts with the input,
      // onChange does not get triggered if they select the first option.
      // For more details see
      // https://github.com/lmigtech/liberty-mutual-design-system/pull/88
      if (onChange) {
        onChange(e);
      }
    }
    if (onFocus) {
      onFocus(e);
    }
  };
  var handleBlur = function handleBlur(e) {
    var onBlur = props.onBlur;
    setIsFocused(false);
    if (onBlur) {
      onBlur(e);
    }
  };
  var handleChange = function handleChange(e) {
    var onChange = props.onChange;
    var hasValue = !!e.target.value;
    /*  This is necessary to remove the `is-focused` class on selection of the `placeholderOption`
     *  This resolves the duplicate `labelVisual`, layout issue. */
    if (!hasValue) {
      setIsFocused(false);
    }
    setHasUncontrolledValue(!!e.target.value);
    if (onChange) {
      onChange(e);
    }
  };

  /**
   * Handles the mouse enter function within Select.
   * This checks to see if onMouseEnter is defined on `inputProps` to ensure desired functionality
   */
  var handleMouseEnter = function handleMouseEnter(e) {
    if (onMouseEnterInputProp) {
      onMouseEnterInputProp(e);
    }
    if (onMouseEnter) {
      onMouseEnter(e);
    }
  };

  /**
   * Handles the mouse leave function within Select.
   * This checks to see if onMouseLeave is defined on `inputProps` to ensure desired functionality
   */
  var handleMouseLeave = function handleMouseLeave(e) {
    if (onMouseLeaveInputProp) {
      onMouseLeaveInputProp(e);
    }
    if (onMouseLeave) {
      onMouseLeave(e);
    }
  };
  var selectIcon = loading ? /*#__PURE__*/React.createElement("div", {
    className: "lm-Field-select--loadingIcon"
  }, loadingIcon || /*#__PURE__*/React.createElement(LoadingSpinner, {
    hiddenTrack: true,
    color: "blue",
    size: "16"
  })) : /*#__PURE__*/React.createElement(IconCaretDown, {
    className: "lmig-Icon-classic",
    color: "gray",
    size: "16",
    ariaHidden: true
  });
  return /*#__PURE__*/React.createElement(Field, _extends({}, props, {
    disabled: disabled || loading,
    isFocused: isFocused,
    isPopulated: isPopulated,
    type: "select",
    labelId: componentId
  }), /*#__PURE__*/React.createElement("select", _extends({
    className: "lm-Field-select",
    defaultValue: defaultValue,
    id: "".concat(componentId, "-select"),
    name: name,
    disabled: disabled || loading,
    "aria-labelledby": "".concat(componentId, "-select-label"),
    "aria-live": loading ? 'polite' : 'off',
    onFocus: handleFocus,
    onBlur: handleBlur,
    onChange: handleChange,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    value: value,
    ref: innerRef,
    "aria-required": isRequired
  }, restInputProps), placeholderOption && /*#__PURE__*/React.createElement(SelectOption, {
    disabled: isRequired,
    value: ""
  }, placeholderOption), children), !disabled || loading ? selectIcon : null, /*#__PURE__*/React.createElement(IconEvo, {
    loading: loading,
    disabled: disabled,
    highlightType: props.highlightType
  }));
};
Select.propTypes = {
  /** Add an optional ID to this element: `<select class="lm-Field-select">`. */id: _pt.string,
  /** Add custom classes to this element. */className: _pt.string,
  /**
     * Used for POST and GET if using the browser’s native form submission functionality.
     * @default ''
     * */
  name: _pt.string,
  /** Select state can be controlled by passing a value to select. */value: _pt.string,
  /** If your component is uncontrolled, use this prop to set the default value.
     * If you are controlling the component, use the `value` prop directly instead. */
  defaultValue: _pt.string,
  /**
     * Use this prop to temporarily disable the select while preserving visual styling
     * during dynamic loading of SelectOption values.
     * @default false
     * */
  loading: _pt.bool,
  /** Pass a different icon, image, or node to display instead of the down caret while options are loading. */loadingIcon: _pt.node,
  /**
     * Disable this select.
     * @default false
     * */
  disabled: _pt.bool,
  /**
     * If this prop is false, selecting the placeholder option will clear the field. If this prop is true, it will not be possible to clear the field once a selection is made.
     * @default true
     * */
  isRequired: _pt.bool,
  /** The text that appears inside the input field and becomes a floating label when focused. */labelVisual: _pt.node.isRequired,
  /** Used with screen readers, optional: this text will replace the labelVisual in audio guidance. */labelA11y: _pt.node,
  /** In most cases, this should match labelVisual. */placeholderOption: _pt.string,
  /** Display some additional helpful text below the select. */helpText: _pt.node,
  /** Apply situational colors and behaviors to this element. */highlightType: _pt.oneOf(['error']),
  /** Pass additional functionality to run on blur events. */onBlur: _pt.func,
  /** Pass additional functionality to run on change events. */onChange: _pt.func,
  /** Pass additional functionality to run on focus events. */onFocus: _pt.func,
  /** Pass additional functionality to run mouse enter events. */onMouseEnter: _pt.func,
  /** Pass additional functionality to run mouse leave events. */onMouseLeave: _pt.func,
  /** Only SelectOption components should be passed as children. Children are rendered in this element: `<select class="lm-Field-select">`. */children: _pt.node
};